import React from 'react';
import TabelaListagem from 'components/TabelaListagem/TabelaListagem';
export default function TabelaListagemGeradores({ items }) {
    const headers = [
        { value: "CPF/CNPJ", objectValue: "cnpj" },
        { value: "Identificação", objectValue: "idetificacaoLocalidade" },
        { value: "Modalidade", objectValue: "tbTipoColeta_Descricao" },
        { value: "Endereço", objectValue: "enderecoCompleto" },
        { value: "Status", objectValue: "status" },
        { value: "Motivo da Não Coleta", objectValue: "motivoNaoColeta" },
    ]
    return (
        <TabelaListagem title={"Lista de geradores"} items={items} headers={headers} options={{ print: false, search: true, pagination: true }} />
    )
}